interface BoxWithCircleInsideSVGProps {
  color: string;
  style: React.CSSProperties;
}

const BoxWithCircleInsideSVG = ({
  color,
  style,
}: BoxWithCircleInsideSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="54"
    viewBox="0 0 46 54"
    fill="none"
  >
    <g clipPath="url(#clip0_564_17756)">
      <path
        d="M6.53699 14.8659C6.53699 16.5116 5.20555 17.8501 3.56854 17.8501C1.93153 17.8501 0.600098 16.5116 0.600098 14.8659C0.600098 13.2202 1.93153 11.8817 3.56854 11.8817C5.20555 11.8817 6.53699 13.2202 6.53699 14.8659Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9628 26.1442C25.9628 27.7899 24.6313 29.1284 22.9943 29.1284C21.3573 29.1284 20.0259 27.7899 20.0259 26.1442C20.0259 24.4986 21.3573 23.1601 22.9943 23.1601C24.6313 23.1601 25.9628 24.4986 25.9628 26.1442Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.3998 14.8659C45.3998 16.5116 44.0683 17.8501 42.4313 17.8501C40.7943 17.8501 39.4629 16.5116 39.4629 14.8659C39.4629 13.2202 40.7943 11.8817 42.4313 11.8817C44.0683 11.8817 45.3998 13.2202 45.3998 14.8659Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9628 3.58758C25.9628 5.23325 24.6313 6.57173 22.9943 6.57173C21.3573 6.57173 20.0259 5.23325 20.0259 3.58758C20.0259 1.9419 21.3573 0.603424 22.9943 0.603424C24.6313 0.603424 25.9628 1.9419 25.9628 3.58758Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.53699 39.1231C6.53699 40.7688 5.20555 42.1073 3.56854 42.1073C1.93153 42.1073 0.600098 40.7688 0.600098 39.1231C0.600098 37.4775 1.93153 36.139 3.56854 36.139C5.20555 36.139 6.53699 37.4775 6.53699 39.1231Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0056 53.3856C24.645 53.3856 25.974 52.0495 25.974 50.4014C25.974 48.7533 24.645 47.4173 23.0056 47.4173C21.3661 47.4173 20.0371 48.7533 20.0371 50.4014C20.0371 52.0495 21.3661 53.3856 23.0056 53.3856Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.3998 39.1231C45.3998 40.7688 44.0683 42.1073 42.4313 42.1073C40.7943 42.1073 39.4629 40.7688 39.4629 39.1231C39.4629 37.4775 40.7943 36.139 42.4313 36.139C44.0683 36.139 45.3998 37.4775 45.3998 39.1231Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1636 6.01218L38.2734 12.4522"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.73779 12.4522L18.8476 6.01218"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.56885 34.0764V19.7042"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8364 47.9988L7.72656 41.5587"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.441 24.6522L7.73779 17.2796"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2735 17.2796L25.5703 24.6522"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0054 29.1284V45.4096"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.4312 34.2958V19.7042"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1636 48.0097L38.2734 41.5587"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1112 22.3921C33.5368 23.566 33.7769 24.8277 33.7769 26.1443C33.7769 31.564 29.8154 36.0512 24.6533 36.8411"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6895 19.2544C16.6648 16.8517 19.6551 15.3157 23.0055 15.3157C26.3559 15.3157 29.3025 16.8298 31.2778 19.2105"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1611 36.8192C16.0863 35.9415 12.2339 31.4982 12.2339 26.1442C12.2339 24.8387 12.4631 23.577 12.8887 22.425"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_17756">
        <rect width="46" height="54" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default BoxWithCircleInsideSVG;
